// UTAL MEA — trilingual translations (English · العربية · Français).
// English is the default. Arabic is RTL. Add a new locale by cloning `en`.
export const translations = {
    en: {
        appName: "UTAL MEA",
        tagline: "Vehicle Registration & Sticker Validation Platform",
        subtagline: "Secure Government Environment",
        // nav
        dashboard: "Dashboard",
        applications: "Applications",
        newApplication: "New Application",
        approvals: "Approvals",
        plates: "Stickers",
        printQueue: "Print Queue",
        scanner: "Field Scanner",
        audit: "Audit Log",
        fraud: "Fraud Watch",
        admin: "Administration",
        publicVerify: "Public Verify",
        signIn: "Sign In",
        signOut: "Sign out",
        more: "More",
        language: "Language",
        // auth
        email: "Email",
        password: "Password",
        login: "Log in",
        loginTitle: "Sign in to UTAL MEA Portal",
        loginSubtitle: "Secure platform for vehicle registration and sticker verification",
        security: "Security",
        mfaTitle: "Two-Factor Verification",
        mfaSubtitle: "Enter the 6-digit code from your authenticator app",
        verify: "Verify",
        // dashboard
        welcome: "Welcome",
        totalApps: "Total Applications",
        pendingReview: "Pending Review",
        approvedCount: "Approved",
        activePlates: "Active Stickers",
        revokedPlates: "Revoked Stickers",
        scans24h: "Scans (24h)",
        fraudFlags: "Fraud Flags",
        // apps
        reference: "Reference",
        ownerName: "Owner Name",
        vin: "VIN",
        status: "Status",
        createdAt: "Created",
        actions: "Actions",
        view: "View",
        search: "Search",
        region: "Region",
        importCSV: "Import CSV",
        importHistory: "History",
        // wizard
        stepOwner: "Owner Details",
        stepVehicle: "Vehicle Details",
        stepDocs: "Documents",
        stepReview: "Review & Submit",
        fullName: "Full Name",
        nationalId: "National ID",
        phone: "Phone",
        address: "Address",
        dob: "Date of Birth",
        make: "Make",
        model: "Model",
        year: "Year",
        color: "Color",
        bodyType: "Body Type",
        engineNumber: "Engine Number",
        fuelType: "Fuel Type",
        addDocument: "Add Document",
        docType: "Document Type",
        docName: "Document Name",
        notes: "Notes",
        submit: "Submit Application",
        next: "Next",
        back: "Back",
        // workflow
        approve: "Approve",
        reject: "Reject",
        needsInfo: "Request Info",
        startReview: "Start Review",
        comment: "Comment",
        // stickers
        plateNumber: "Sticker Number",
        issue: "Issue",
        issuePlate: "Issue Sticker",
        print: "Print",
        revoke: "Revoke",
        active: "Active",
        revoked: "Revoked",
        // scanner
        scannerTitle: "Verify Sticker",
        scannerHint: "Point camera at the QR code on the sticker",
        startScan: "Start Scan",
        stopScan: "Stop",
        valid: "VALID",
        invalid: "INVALID",
        warning: "WARNING",
        // audit
        chainIntact: "Audit chain intact",
        chainBroken: "Tampering detected!",
        // roles
        role_super_admin: "Super Admin",
        role_registrar: "Registrar",
        role_approver: "Approver",
        role_printer_operator: "Printer Op.",
        role_enforcement_officer: "Field Officer",
        role_auditor: "Auditor",
        role_read_only: "Read Only",
        // demo tour
        tour_kicker: "Quick tour",
        tour_lang_title: "Three languages, one click",
        tour_lang_body: "Every screen is fully translated to English, Arabic (RTL), and French. Switch anytime from the button in the top-right — the label always shows the next language.",
        tour_lang_try: "Try it →",
        tour_sticker_title: "Signed windshield sticker",
        tour_sticker_body: "Every approved vehicle gets a tamper-evident Zebra-printed sticker with a signed QR code, an expiry date, and a unique key ID — impossible to forge.",
        tour_verify_title: "Field verification in 2 seconds",
        tour_verify_body: "Officers scan the QR from any phone — online or offline — and instantly see one of three outcomes.",
        tour_verify_footer: "Works offline for 24 h using cached signing keys and a signed revocation feed.",
        tour_skip: "Skip tour",
        tour_finish: "Get started",
        // misc
        loading: "Loading…",
        noData: "No data",
        success: "Success",
        error: "Error",
        confirm: "Confirm",
        cancel: "Cancel",
        save: "Save",
        add: "Add",
        remove: "Remove",
        edit: "Edit",
        refresh: "Refresh",
        reset: "Reset",
        close: "Close",
        space: "Space",
        backspace: "Back",
        // admin
        adminPendingEmpty: "Queue empty. New Google sign-ins from allowlisted domains will appear here.",
        adminAllowlistTitle: "Auth Allowlist (Google sign-in gate)",
        adminUsersRoles: "Users & roles",
        adminAllSessions: "All Active Sessions",
        adminNoSessions: "No active sessions",
        adminNoRegions: "No regions",
        adminKidCol: "KID",
        adminAlgo: "Algo",
        adminProvider: "Provider",
        adminDevice: "Device",
        adminIP: "IP",
        adminRotateKey: "Rotate",
        adminRotated: "Rotated",
        adminReject: "Reject",
        adminImport: "Import",
        adminRetired: "Retired",
        adminSizeMm: "W×H (mm)",
        adminBuiltIn: "BUILT-IN",
        adminLabel: "Label",
        adminType: "Type",
        adminValue: "Value",
        adminAdded: "Added",
        adminName: "Name",
        adminCode: "Code",
        adminHost: "Host",
        adminPort: "Port",
        adminPing: "Ping",
        adminClearConfig: "Clear config",
        adminNotSet: "NOT SET",
        adminBalance: "Balance",
        adminLiveEnv: "LIVE · ENV",
        adminLiveDb: "LIVE · DB",
        adminMocked: "MOCKED",
        adminSessionLifetime: "Session Lifetime",
        adminMfaTitle: "Two-Factor Authentication",
        adminEnableMfa: "Enable MFA",
        adminDisableMfa: "Disable MFA",
        adminMfaEnabled: "MFA enabled",
        adminMfaDisabled: "MFA disabled",
        adminInvalidCode: "Invalid code",
        adminShiftPin: "Shift PIN (Field Handover)",
        adminActiveSessions: "Active Sessions",
        adminVerificationCode: "Verification code",
        adminEnable: "Enable",
        // applications / csv
        csvHistoryTitle: "CSV import history",
        csvNoImports: "No imports yet.",
        csvWhen: "When",
        csvBy: "By",
        csvRows: "Rows",
        csvCreated: "Created",
        csvSkipped: "Skipped",
        csvFirstRef: "First ref",
        csvBulkTitle: "Bulk import applications from CSV",
        csvBulkHint: "Paste rows or upload a CSV file. Duplicates and unknown regions are skipped automatically.",
        // audit
        auditAll: "All events",
        auditSigninOnly: "Sign-ins only",
        auditPrintOnly: "Print jobs",
        auditTimestamp: "Timestamp",
        auditActor: "Actor",
        auditAction: "Action",
        auditDeviceIp: "Device / IP",
        auditEntity: "Entity",
        auditHash: "Hash",
        auditNewIp: "NEW IP",
        // fraud
        fraudFlagsCol: "Flags",
        // scanner / handover
        scannerSignals: "Signals",
        scannerPlateRecord: "Plate record",
        scannerEndShift: "End shift & hand over",
        scannerAcceptShift: "Accept the shift",
        scannerCamHttps: "Camera requires HTTPS. Open this page over https:// instead.",
        scannerBrowserNoCam: "This browser doesn't support camera access. Try Chrome or Safari.",
        scannerShiftEnded: "Shift ended. Handover ready.",
        // plates
        platePreviewTitle: "Plate label preview",
        plateRevoked: "Revoked",
        plateApproved: "Approved",
        plateReason: "Reason",
        plateBatchClear: "Clear",
        plateNoPrintJobs: "No print jobs yet.",
        // demo
        demoNoInvites: "No demo invites yet. Send one above to get started.",
        demoDemoUsers: "Demo user invites",
        demoDemoStickers: "Demo stickers",
        demoStickersEmpty: "No demo stickers yet. Click Seed demo stickers above.",
        demoInviteCopied: "Invite link copied",
        demoDaysLabel: "Days",
        // misc
        toastCreated: "Created",
        toastRemoved: "Removed",
        toastApproved: "Approved",
        toastRejected: "Rejected",
        toastRevoked: "Revoked",
        toastSaved: "Saved",
        toastFailed: "Failed",
        toastRetired: "Retired",
        // sticker face
        stickerValidUntil: "Valid until",
        stickerNo: "No.",
        stickerCopyVoid: "COPY VOID",
        stickerRevoked: "REVOKED",
        stickerMicroPhrase: "UTAL·MEA·GENUINE·",
        // plate lookup / violations
        "plate-lookup": "Plate Lookup",
        plateLookupTitle: "Vehicle Plate Lookup",
        plateLookupHint: "Enter a license plate to view owner, vehicle, sticker status, and violation history.",
        plateNotFound: "Plate not found in registry — you may still issue a violation.",
        violationsHistory: "Violations",
        noViolations: "No violations on record.",
        issueViolation: "Issue Violation",
        violationType: "Violation type",
        fineAmount: "Fine amount",
        currency: "Currency",
        location: "Location",
        violationIssued: "Violation issued",
        // aluminum plate designer + violations admin
        "aluminum-plates": "Aluminum Plates",
        violations: "Violations",
        aluminumDesignerTitle: "Aluminum plate designer",
        aluminumDesignerHint: "Preview a German-standard aluminum plate for private, taxi, temporary, or motorcycle vehicles — then send it to production.",
        aluminumPickPlate: "Pick a registered plate",
        aluminumPickPlateFirst: "Pick a registered plate first to enable print-to-production.",
        aluminumSize: "Size",
        aluminumCategory: "Category",
        aluminumLong: "Long car (520×110)",
        aluminumShort: "Short car (340×110)",
        aluminumMoto: "Motorcycle (180×200)",
        aluminumPrivate: "Private",
        aluminumTaxi: "Taxi",
        aluminumTemporary: "Temporary",
        aluminumMotorcycle: "Motorcycle",
        aluminumExpiryBand: "Expiry band",
        aluminumSendToProduction: "Send to production",
        aluminumSentToProduction: "Sent to production",
        violationsAdminTitle: "Traffic violations",
        violationsAdminHint: "All issued citations. Mark as paid once the fine is settled, or dismiss on appeal.",
        statusOpen: "Open",
        statusPaid: "Paid",
        statusDismissed: "Dismissed",
        violationMarkedPaid: "Marked as paid",
        violationDismissed: "Dismissed",
        exportSuccess: "Exported",
        // LPN auto-suggest
        lpnSuggestTip: "Use the next available plate number for this region",
        lpnUseSuggest: "Use suggested",
        lpnNextAvailable: "Next available",
        // On-the-spot printing
        issueAndPrint: "Issue & print",
        violationPrintedOnSpot: "Citation printed on-the-spot",
        violationPrintFailed: "Print failed — citation still saved",
        // Electric plate + owner push alerts + PDF citation
        aluminumElectric: "Electric (E)",
        plateAlertsTitle: "Get plate alert notifications",
        plateAlertsHint: "Subscribe your device to receive an instant push whenever a violation is issued for your plate.",
        plateAlertsSubscribe: "Subscribe",
        plateAlertsEnrolled: "You're now subscribed to plate alerts.",
        plateAlertsEnrolledLong: "Enrolled — you'll get a push notification the moment any officer issues a citation for this plate.",
        plateAlertsNotSupported: "Web Push isn't supported on this browser.",
        plateAlertsPermissionDenied: "Notification permission denied.",
        plateAlertsPrivacy: "We store only your plate number and browser push endpoint. Remove anytime.",
        // Owner portal + citation verify
        ownerPortalTitle: "Owner portal",
        ownerPortalHint: "Enter your plate number and national ID to view outstanding violations and pay online.",
        ownerPortalLookup: "Look up",
        ownerPortalPrivacy: "We verify the national ID against the encrypted hash captured at plate issuance — nothing is stored.",
        ownerPortalOpen: "Open violations",
        ownerPortalHistory: "History",
        ownerPortalNoOpen: "No open violations. You're all clear.",
        ownerPortalOpenTotal: "Total due",
        ownerPortalPay: "Pay",
        ownerPortalPaid: "Payment confirmed",
        citationVerifyTitle: "Citation verification",
        citationVerifyHint: "This is a public read-only view of a UTAL MEA traffic citation. Scanned from a printed PDF's QR code.",
        citationVerifyFooter: "Records shown match the on-file citation. Contest within 14 days at the nearest traffic bureau.",
        citationVerifyPayCta: "Owner? Pay online →",
        citationSignatureTitle: "Cryptographic signature",
        citationSignatureValid: "Verified",
        citationSignatureInvalid: "Invalid",
        citationSignatureAlgo: "Algorithm",
        citationSignatureHelp: "This citation was signed with the ministry's Ed25519 key at the moment of issue. Any tampering will invalidate the signature.",
    },
    ar: {
        appName: "UTAL MEA",
        tagline: "منصة تسجيل المركبات والتحقق من الملصقات",
        subtagline: "بيئة حكومية آمنة",
        dashboard: "لوحة القيادة",
        applications: "طلبات التسجيل",
        newApplication: "طلب جديد",
        approvals: "الموافقات",
        plates: "الملصقات",
        printQueue: "طابور الطباعة",
        scanner: "الماسح الميداني",
        audit: "سجل التدقيق",
        fraud: "مراقبة الاحتيال",
        admin: "الإدارة",
        publicVerify: "التحقق العام",
        signIn: "تسجيل الدخول",
        signOut: "تسجيل الخروج",
        more: "المزيد",
        language: "اللغة",
        email: "البريد الإلكتروني",
        password: "كلمة المرور",
        login: "دخول",
        loginTitle: "تسجيل الدخول إلى بوابة UTAL MEA",
        loginSubtitle: "منصة آمنة لتسجيل المركبات والتحقق من الملصقات",
        security: "الأمن",
        mfaTitle: "رمز التحقق الثنائي",
        mfaSubtitle: "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة",
        verify: "تحقق",
        welcome: "أهلاً",
        totalApps: "إجمالي الطلبات",
        pendingReview: "قيد المراجعة",
        approvedCount: "تمت الموافقة",
        activePlates: "ملصقات نشطة",
        revokedPlates: "ملصقات ملغاة",
        scans24h: "عمليات مسح آخر 24 ساعة",
        fraudFlags: "إشارات احتيال",
        reference: "المرجع",
        ownerName: "اسم المالك",
        vin: "رقم الهيكل",
        status: "الحالة",
        createdAt: "تاريخ الإنشاء",
        actions: "إجراءات",
        view: "عرض",
        search: "بحث",
        region: "المنطقة",
        importCSV: "استيراد CSV",
        importHistory: "السجل",
        stepOwner: "بيانات المالك",
        stepVehicle: "بيانات المركبة",
        stepDocs: "الوثائق",
        stepReview: "مراجعة وإرسال",
        fullName: "الاسم الكامل",
        nationalId: "الرقم الوطني",
        phone: "الهاتف",
        address: "العنوان",
        dob: "تاريخ الميلاد",
        make: "الصانع",
        model: "الطراز",
        year: "السنة",
        color: "اللون",
        bodyType: "نوع الهيكل",
        engineNumber: "رقم المحرك",
        fuelType: "نوع الوقود",
        addDocument: "إضافة وثيقة",
        docType: "نوع الوثيقة",
        docName: "اسم الوثيقة",
        notes: "ملاحظات",
        submit: "إرسال الطلب",
        next: "التالي",
        back: "السابق",
        approve: "موافقة",
        reject: "رفض",
        needsInfo: "معلومات إضافية",
        startReview: "بدء المراجعة",
        comment: "تعليق",
        plateNumber: "رقم الملصق",
        issue: "إصدار",
        issuePlate: "إصدار ملصق",
        print: "طباعة",
        revoke: "إلغاء",
        active: "نشط",
        revoked: "ملغى",
        scannerTitle: "التحقق من الملصق",
        scannerHint: "وجّه الكاميرا نحو رمز QR الموجود على الملصق",
        startScan: "بدء المسح",
        stopScan: "إيقاف",
        valid: "صالح",
        invalid: "غير صالح",
        warning: "تحذير",
        chainIntact: "سلسلة السجل سليمة",
        chainBroken: "تم اكتشاف تلاعب!",
        role_super_admin: "مدير عام",
        role_registrar: "مسجّل",
        role_approver: "معتمِد",
        role_printer_operator: "مشغل طابعة",
        role_enforcement_officer: "ضابط ميداني",
        role_auditor: "مدقّق",
        role_read_only: "قراءة فقط",
        tour_kicker: "جولة سريعة",
        tour_lang_title: "ثلاث لغات، بنقرة واحدة",
        tour_lang_body: "كل شاشة مترجمة بالكامل إلى الإنجليزية والعربية (اتجاه من اليمين لليسار) والفرنسية. بدّل اللغة في أي وقت من الزر في الأعلى — يعرض الزر دائماً اللغة التالية.",
        tour_lang_try: "جرّب ←",
        tour_sticker_title: "ملصق مقاوم للتزوير على الزجاج الأمامي",
        tour_sticker_body: "كل مركبة معتمدة تحصل على ملصق مطبوع بطابعة Zebra مع رمز QR موقّع رقمياً وتاريخ انتهاء ومعرّف مفتاح فريد — يستحيل تزويره.",
        tour_verify_title: "تحقق ميداني في ثانيتين",
        tour_verify_body: "يمسح الضباط رمز QR من أي هاتف — أونلاين أو أوفلاين — ويرون فوراً واحدة من ثلاث نتائج.",
        tour_verify_footer: "يعمل بلا إنترنت لمدة 24 ساعة باستخدام المفاتيح المخزنة وقائمة إلغاء موقّعة.",
        tour_skip: "تخطي الجولة",
        tour_finish: "لنبدأ",
        loading: "جارِ التحميل…",
        noData: "لا توجد بيانات",
        success: "تم بنجاح",
        error: "خطأ",
        confirm: "تأكيد",
        cancel: "إلغاء",
        save: "حفظ",
        add: "إضافة",
        remove: "إزالة",
        edit: "تعديل",
        refresh: "تحديث",
        reset: "إعادة تعيين",
        close: "إغلاق",
        space: "مسافة",
        backspace: "حذف",
        adminPendingEmpty: "الطابور فارغ. ستظهر هنا عمليات تسجيل الدخول الجديدة عبر Google من النطاقات المسموح بها.",
        adminAllowlistTitle: "قائمة السماح للمصادقة (بوابة تسجيل الدخول عبر Google)",
        adminUsersRoles: "المستخدمون والأدوار",
        adminAllSessions: "جميع الجلسات النشطة",
        adminNoSessions: "لا توجد جلسات نشطة",
        adminNoRegions: "لا توجد مناطق",
        adminKidCol: "معرّف المفتاح",
        adminAlgo: "الخوارزمية",
        adminProvider: "المزوّد",
        adminDevice: "الجهاز",
        adminIP: "IP",
        adminRotateKey: "تدوير",
        adminRotated: "تم التدوير",
        adminReject: "رفض",
        adminImport: "استيراد",
        adminRetired: "متقاعد",
        adminSizeMm: "الأبعاد (مم)",
        adminBuiltIn: "افتراضي",
        adminLabel: "التسمية",
        adminType: "النوع",
        adminValue: "القيمة",
        adminAdded: "أُضيف",
        adminName: "الاسم",
        adminCode: "الرمز",
        adminHost: "المضيف",
        adminPort: "المنفذ",
        adminPing: "اختبار",
        adminClearConfig: "مسح الإعدادات",
        adminNotSet: "غير مضبوط",
        adminBalance: "الرصيد",
        adminLiveEnv: "مباشر · ENV",
        adminLiveDb: "مباشر · DB",
        adminMocked: "وهمي",
        adminSessionLifetime: "مدة الجلسة",
        adminMfaTitle: "المصادقة الثنائية",
        adminEnableMfa: "تفعيل المصادقة الثنائية",
        adminDisableMfa: "تعطيل المصادقة الثنائية",
        adminMfaEnabled: "تم تفعيل المصادقة الثنائية",
        adminMfaDisabled: "تم تعطيل المصادقة الثنائية",
        adminInvalidCode: "رمز غير صالح",
        adminShiftPin: "رقم دخول الوردية (تسليم ميداني)",
        adminActiveSessions: "الجلسات النشطة",
        adminVerificationCode: "رمز التحقق",
        adminEnable: "تفعيل",
        csvHistoryTitle: "سجل استيراد CSV",
        csvNoImports: "لا توجد عمليات استيراد بعد.",
        csvWhen: "الوقت",
        csvBy: "بواسطة",
        csvRows: "الأسطر",
        csvCreated: "تم إنشاؤها",
        csvSkipped: "تم تخطيها",
        csvFirstRef: "أول مرجع",
        csvBulkTitle: "استيراد الطلبات دفعة واحدة من CSV",
        csvBulkHint: "الصق الأسطر أو ارفع ملف CSV. يتم تخطي التكرارات والمناطق غير المعروفة تلقائياً.",
        auditAll: "جميع الأحداث",
        auditSigninOnly: "تسجيلات الدخول فقط",
        auditPrintOnly: "مهام الطباعة",
        auditTimestamp: "التاريخ والوقت",
        auditActor: "المستخدم",
        auditAction: "الحدث",
        auditDeviceIp: "الجهاز / IP",
        auditEntity: "الكيان",
        auditHash: "البصمة",
        auditNewIp: "IP جديد",
        fraudFlagsCol: "الإشارات",
        scannerSignals: "الإشارات",
        scannerPlateRecord: "سجل الملصق",
        scannerEndShift: "إنهاء الوردية والتسليم",
        scannerAcceptShift: "قبول الوردية",
        scannerCamHttps: "تتطلب الكاميرا HTTPS. افتح الصفحة عبر https:// بدلاً من ذلك.",
        scannerBrowserNoCam: "هذا المتصفح لا يدعم الكاميرا. جرّب Chrome أو Safari.",
        scannerShiftEnded: "انتهت الوردية. جاهز للتسليم.",
        platePreviewTitle: "معاينة ملصق التسجيل",
        plateRevoked: "ملغى",
        plateApproved: "تمت الموافقة",
        plateReason: "السبب",
        plateBatchClear: "مسح",
        plateNoPrintJobs: "لا توجد مهام طباعة بعد.",
        demoNoInvites: "لا توجد دعوات تجريبية بعد. أرسل واحدة أعلاه للبدء.",
        demoDemoUsers: "دعوات المستخدمين التجريبيين",
        demoDemoStickers: "الملصقات التجريبية",
        demoStickersEmpty: "لا توجد ملصقات تجريبية بعد. انقر على «إنشاء ملصقات تجريبية» أعلاه.",
        demoInviteCopied: "تم نسخ رابط الدعوة",
        demoDaysLabel: "أيام",
        toastCreated: "تم الإنشاء",
        toastRemoved: "تمت الإزالة",
        toastApproved: "تمت الموافقة",
        toastRejected: "تم الرفض",
        toastRevoked: "تم الإلغاء",
        toastSaved: "تم الحفظ",
        toastFailed: "فشل",
        toastRetired: "تمت الإحالة إلى التقاعد",
        stickerValidUntil: "صالح حتى",
        stickerNo: "رقم",
        stickerCopyVoid: "نسخة باطلة",
        stickerRevoked: "ملغى",
        stickerMicroPhrase: "UTAL·MEA·أصلي·",
        "plate-lookup": "بحث اللوحات",
        plateLookupTitle: "البحث عن لوحة مركبة",
        plateLookupHint: "أدخل رقم اللوحة لعرض المالك والمركبة وحالة الملصق وسجل المخالفات.",
        plateNotFound: "اللوحة غير موجودة في السجل — لا يزال بإمكانك إصدار مخالفة.",
        violationsHistory: "المخالفات",
        noViolations: "لا توجد مخالفات مسجلة.",
        issueViolation: "إصدار مخالفة",
        violationType: "نوع المخالفة",
        fineAmount: "قيمة الغرامة",
        currency: "العملة",
        location: "المكان",
        violationIssued: "تم إصدار المخالفة",
        "aluminum-plates": "اللوحات المعدنية",
        violations: "المخالفات",
        aluminumDesignerTitle: "مصمم اللوحات المعدنية",
        aluminumDesignerHint: "معاينة لوحة معدنية بالمقاسات الألمانية القياسية للمركبات الخاصة أو التاكسي أو المؤقتة أو الدراجات النارية — ثم إرسالها للإنتاج.",
        aluminumPickPlate: "اختر لوحة مسجلة",
        aluminumPickPlateFirst: "اختر لوحة مسجلة أولاً لتفعيل الإرسال للإنتاج.",
        aluminumSize: "المقاس",
        aluminumCategory: "الفئة",
        aluminumLong: "سيارة طويلة (520×110)",
        aluminumShort: "سيارة قصيرة (340×110)",
        aluminumMoto: "دراجة نارية (180×200)",
        aluminumPrivate: "خاص",
        aluminumTaxi: "تاكسي",
        aluminumTemporary: "مؤقت",
        aluminumMotorcycle: "دراجة نارية",
        aluminumExpiryBand: "شريط الانتهاء",
        aluminumSendToProduction: "إرسال للإنتاج",
        aluminumSentToProduction: "تم الإرسال للإنتاج",
        violationsAdminTitle: "المخالفات المرورية",
        violationsAdminHint: "جميع المخالفات الصادرة. ضع علامة مدفوعة عند تسوية الغرامة أو استبعدها عند الطعن.",
        statusOpen: "مفتوحة",
        statusPaid: "مدفوعة",
        statusDismissed: "مُستبعدة",
        violationMarkedPaid: "تم وضعها كمدفوعة",
        violationDismissed: "تم استبعادها",
        exportSuccess: "تم التصدير",
        lpnSuggestTip: "استخدم رقم اللوحة التالي المتاح لهذه المنطقة",
        lpnUseSuggest: "استخدم المقترح",
        lpnNextAvailable: "التالي المتاح",
        issueAndPrint: "إصدار وطباعة",
        violationPrintedOnSpot: "تمت طباعة المخالفة فوراً",
        violationPrintFailed: "فشلت الطباعة — تم حفظ المخالفة",
        aluminumElectric: "كهربائية (E)",
        plateAlertsTitle: "احصل على تنبيهات المخالفات",
        plateAlertsHint: "اشترك بجهازك لتلقي إشعار فوري عند إصدار مخالفة على لوحتك.",
        plateAlertsSubscribe: "اشتراك",
        plateAlertsEnrolled: "تم الاشتراك في تنبيهات اللوحة.",
        plateAlertsEnrolledLong: "تم الاشتراك — ستصلك إشعارات فورية عند إصدار مخالفة على هذه اللوحة.",
        plateAlertsNotSupported: "المتصفح لا يدعم Web Push.",
        plateAlertsPermissionDenied: "تم رفض إذن الإشعارات.",
        plateAlertsPrivacy: "نحفظ فقط رقم اللوحة ونقطة اشتراك المتصفح. يمكنك الإلغاء في أي وقت.",
        ownerPortalTitle: "بوابة المالك",
        ownerPortalHint: "أدخل رقم اللوحة والرقم الوطني لعرض المخالفات المستحقة والدفع عبر الإنترنت.",
        ownerPortalLookup: "بحث",
        ownerPortalPrivacy: "نتحقق من الرقم الوطني عبر التجزئة المشفرة المسجلة عند إصدار اللوحة — دون تخزين البيانات.",
        ownerPortalOpen: "مخالفات مفتوحة",
        ownerPortalHistory: "السجل",
        ownerPortalNoOpen: "لا توجد مخالفات مفتوحة. أنت خالٍ من المخالفات.",
        ownerPortalOpenTotal: "الإجمالي المستحق",
        ownerPortalPay: "ادفع",
        ownerPortalPaid: "تم تأكيد الدفع",
        citationVerifyTitle: "التحقق من المخالفة",
        citationVerifyHint: "هذه صفحة عامة للقراءة فقط لمخالفة صادرة عن UTAL MEA. تم الوصول إليها عبر رمز QR على النسخة المطبوعة.",
        citationVerifyFooter: "السجلات المعروضة مطابقة للسجل. يمكن الطعن خلال 14 يوماً في أقرب دائرة مرور.",
        citationVerifyPayCta: "هل أنت المالك؟ ادفع عبر الإنترنت ←",
        citationSignatureTitle: "التوقيع التشفيري",
        citationSignatureValid: "تم التحقق",
        citationSignatureInvalid: "غير صالح",
        citationSignatureAlgo: "الخوارزمية",
        citationSignatureHelp: "تم توقيع هذه المخالفة بمفتاح Ed25519 الخاص بالوزارة لحظة إصدارها. أي تعديل يبطل التوقيع.",
    },
    fr: {
        appName: "UTAL MEA",
        tagline: "Plateforme d'immatriculation et de validation des vignettes",
        subtagline: "Environnement gouvernemental sécurisé",
        dashboard: "Tableau de bord",
        applications: "Demandes",
        newApplication: "Nouvelle demande",
        approvals: "Approbations",
        plates: "Vignettes",
        printQueue: "File d'impression",
        scanner: "Scanner de terrain",
        audit: "Journal d'audit",
        fraud: "Surveillance des fraudes",
        admin: "Administration",
        publicVerify: "Vérification publique",
        signIn: "Connexion",
        signOut: "Déconnexion",
        more: "Plus",
        language: "Langue",
        email: "E-mail",
        password: "Mot de passe",
        login: "Se connecter",
        loginTitle: "Connexion au portail UTAL MEA",
        loginSubtitle: "Plateforme sécurisée d'immatriculation et de vérification des vignettes",
        security: "Sécurité",
        mfaTitle: "Vérification à deux facteurs",
        mfaSubtitle: "Saisissez le code à 6 chiffres de votre application d'authentification",
        verify: "Vérifier",
        welcome: "Bienvenue",
        totalApps: "Total des demandes",
        pendingReview: "En attente",
        approvedCount: "Approuvées",
        activePlates: "Vignettes actives",
        revokedPlates: "Vignettes révoquées",
        scans24h: "Scans (24h)",
        fraudFlags: "Signalements",
        reference: "Référence",
        ownerName: "Propriétaire",
        vin: "NIV",
        status: "Statut",
        createdAt: "Créé le",
        actions: "Actions",
        view: "Voir",
        search: "Rechercher",
        region: "Région",
        importCSV: "Importer CSV",
        importHistory: "Historique",
        stepOwner: "Détails du propriétaire",
        stepVehicle: "Détails du véhicule",
        stepDocs: "Documents",
        stepReview: "Vérifier et soumettre",
        fullName: "Nom complet",
        nationalId: "Identifiant national",
        phone: "Téléphone",
        address: "Adresse",
        dob: "Date de naissance",
        make: "Marque",
        model: "Modèle",
        year: "Année",
        color: "Couleur",
        bodyType: "Carrosserie",
        engineNumber: "N° moteur",
        fuelType: "Carburant",
        addDocument: "Ajouter un document",
        docType: "Type de document",
        docName: "Nom du document",
        notes: "Notes",
        submit: "Soumettre",
        next: "Suivant",
        back: "Retour",
        approve: "Approuver",
        reject: "Rejeter",
        needsInfo: "Demander des infos",
        startReview: "Démarrer l'examen",
        comment: "Commentaire",
        plateNumber: "N° vignette",
        issue: "Émettre",
        issuePlate: "Émettre une vignette",
        print: "Imprimer",
        revoke: "Révoquer",
        active: "Active",
        revoked: "Révoquée",
        scannerTitle: "Vérifier la vignette",
        scannerHint: "Pointez la caméra vers le QR code de la vignette",
        startScan: "Démarrer",
        stopScan: "Arrêter",
        valid: "VALIDE",
        invalid: "INVALIDE",
        warning: "ATTENTION",
        chainIntact: "Chaîne d'audit intacte",
        chainBroken: "Falsification détectée !",
        role_super_admin: "Super Admin",
        role_registrar: "Registraire",
        role_approver: "Approbateur",
        role_printer_operator: "Opérateur",
        role_enforcement_officer: "Agent de terrain",
        role_auditor: "Auditeur",
        role_read_only: "Lecture seule",
        tour_kicker: "Visite guidée",
        tour_lang_title: "Trois langues, un clic",
        tour_lang_body: "Chaque écran est intégralement traduit en anglais, en arabe (RTL) et en français. Changez de langue à tout moment depuis le bouton en haut à droite — l'étiquette affiche toujours la prochaine langue.",
        tour_lang_try: "Essayez →",
        tour_sticker_title: "Vignette pare-brise signée",
        tour_sticker_body: "Chaque véhicule approuvé reçoit une vignette Zebra inviolable avec un QR signé, une date d'expiration et un identifiant de clé unique — infalsifiable.",
        tour_verify_title: "Vérification terrain en 2 secondes",
        tour_verify_body: "Les agents scannent le QR depuis n'importe quel téléphone — en ligne ou hors ligne — et voient immédiatement l'un des trois résultats.",
        tour_verify_footer: "Fonctionne hors ligne pendant 24 h grâce aux clés en cache et à un flux de révocation signé.",
        tour_skip: "Passer",
        tour_finish: "Commencer",
        loading: "Chargement…",
        noData: "Aucune donnée",
        success: "Succès",
        error: "Erreur",
        confirm: "Confirmer",
        cancel: "Annuler",
        save: "Enregistrer",
        add: "Ajouter",
        remove: "Retirer",
        edit: "Modifier",
        refresh: "Actualiser",
        reset: "Réinitialiser",
        close: "Fermer",
        space: "Espace",
        backspace: "Retour",
        adminPendingEmpty: "File vide. Les nouvelles connexions Google des domaines autorisés apparaîtront ici.",
        adminAllowlistTitle: "Liste d'autorisation (accès Google)",
        adminUsersRoles: "Utilisateurs et rôles",
        adminAllSessions: "Toutes les sessions actives",
        adminNoSessions: "Aucune session active",
        adminNoRegions: "Aucune région",
        adminKidCol: "KID",
        adminAlgo: "Algo",
        adminProvider: "Fournisseur",
        adminDevice: "Appareil",
        adminIP: "IP",
        adminRotateKey: "Rotation",
        adminRotated: "Pivotée",
        adminReject: "Rejeter",
        adminImport: "Importer",
        adminRetired: "Retirée",
        adminSizeMm: "L × H (mm)",
        adminBuiltIn: "INTÉGRÉ",
        adminLabel: "Libellé",
        adminType: "Type",
        adminValue: "Valeur",
        adminAdded: "Ajouté",
        adminName: "Nom",
        adminCode: "Code",
        adminHost: "Hôte",
        adminPort: "Port",
        adminPing: "Ping",
        adminClearConfig: "Effacer la config",
        adminNotSet: "NON DÉFINI",
        adminBalance: "Solde",
        adminLiveEnv: "ACTIF · ENV",
        adminLiveDb: "ACTIF · DB",
        adminMocked: "SIMULÉ",
        adminSessionLifetime: "Durée de session",
        adminMfaTitle: "Authentification à deux facteurs",
        adminEnableMfa: "Activer 2FA",
        adminDisableMfa: "Désactiver 2FA",
        adminMfaEnabled: "2FA activée",
        adminMfaDisabled: "2FA désactivée",
        adminInvalidCode: "Code invalide",
        adminShiftPin: "PIN de service (Passation terrain)",
        adminActiveSessions: "Sessions actives",
        adminVerificationCode: "Code de vérification",
        adminEnable: "Activer",
        csvHistoryTitle: "Historique d'import CSV",
        csvNoImports: "Aucun import pour l'instant.",
        csvWhen: "Quand",
        csvBy: "Par",
        csvRows: "Lignes",
        csvCreated: "Créées",
        csvSkipped: "Ignorées",
        csvFirstRef: "1ère réf.",
        csvBulkTitle: "Import CSV en masse des demandes",
        csvBulkHint: "Collez des lignes ou téléversez un CSV. Les doublons et régions inconnues sont ignorés automatiquement.",
        auditAll: "Tous les événements",
        auditSigninOnly: "Connexions uniquement",
        auditPrintOnly: "Travaux d'impression",
        auditTimestamp: "Horodatage",
        auditActor: "Acteur",
        auditAction: "Action",
        auditDeviceIp: "Appareil / IP",
        auditEntity: "Entité",
        auditHash: "Empreinte",
        auditNewIp: "NOUVELLE IP",
        fraudFlagsCol: "Signalements",
        scannerSignals: "Signaux",
        scannerPlateRecord: "Fiche vignette",
        scannerEndShift: "Terminer et passer le service",
        scannerAcceptShift: "Prendre le service",
        scannerCamHttps: "La caméra requiert HTTPS. Ouvrez cette page en https:// à la place.",
        scannerBrowserNoCam: "Ce navigateur ne prend pas en charge la caméra. Essayez Chrome ou Safari.",
        scannerShiftEnded: "Service terminé. Passation prête.",
        platePreviewTitle: "Aperçu de la vignette",
        plateRevoked: "Révoquée",
        plateApproved: "Approuvée",
        plateReason: "Motif",
        plateBatchClear: "Effacer",
        plateNoPrintJobs: "Aucune impression pour l'instant.",
        demoNoInvites: "Aucune invitation démo. Envoyez-en une ci-dessus pour commencer.",
        demoDemoUsers: "Invitations utilisateurs démo",
        demoDemoStickers: "Vignettes démo",
        demoStickersEmpty: "Pas encore de vignettes démo. Cliquez sur « Semer vignettes démo » ci-dessus.",
        demoInviteCopied: "Lien d'invitation copié",
        demoDaysLabel: "Jours",
        toastCreated: "Créé",
        toastRemoved: "Retiré",
        toastApproved: "Approuvé",
        toastRejected: "Rejeté",
        toastRevoked: "Révoqué",
        toastSaved: "Enregistré",
        toastFailed: "Échec",
        toastRetired: "Mis au repos",
        stickerValidUntil: "Valide jusqu'au",
        stickerNo: "N°",
        stickerCopyVoid: "COPIE NULLE",
        stickerRevoked: "RÉVOQUÉE",
        stickerMicroPhrase: "UTAL·MEA·AUTHENTIQUE·",
        "plate-lookup": "Recherche plaque",
        plateLookupTitle: "Recherche de plaque",
        plateLookupHint: "Saisissez un numéro de plaque pour voir le propriétaire, le véhicule, l'état de la vignette et l'historique des infractions.",
        plateNotFound: "Plaque introuvable dans le registre — vous pouvez tout de même émettre une infraction.",
        violationsHistory: "Infractions",
        noViolations: "Aucune infraction enregistrée.",
        issueViolation: "Émettre une infraction",
        violationType: "Type d'infraction",
        fineAmount: "Montant de l'amende",
        currency: "Devise",
        location: "Lieu",
        violationIssued: "Infraction émise",
        "aluminum-plates": "Plaques alu",
        violations: "Infractions",
        aluminumDesignerTitle: "Concepteur de plaques aluminium",
        aluminumDesignerHint: "Prévisualisez une plaque aluminium aux standards allemands pour un véhicule privé, taxi, temporaire ou moto — puis envoyez-la en production.",
        aluminumPickPlate: "Choisir une plaque enregistrée",
        aluminumPickPlateFirst: "Choisissez d'abord une plaque enregistrée pour activer l'envoi en production.",
        aluminumSize: "Taille",
        aluminumCategory: "Catégorie",
        aluminumLong: "Voiture long (520×110)",
        aluminumShort: "Voiture court (340×110)",
        aluminumMoto: "Moto (180×200)",
        aluminumPrivate: "Privé",
        aluminumTaxi: "Taxi",
        aluminumTemporary: "Temporaire",
        aluminumMotorcycle: "Moto",
        aluminumExpiryBand: "Bande d'expiration",
        aluminumSendToProduction: "Envoyer en production",
        aluminumSentToProduction: "Envoyé en production",
        violationsAdminTitle: "Infractions routières",
        violationsAdminHint: "Toutes les citations émises. Marquez comme payé quand l'amende est réglée, ou classez sans suite sur appel.",
        statusOpen: "Ouverte",
        statusPaid: "Payée",
        statusDismissed: "Classée",
        violationMarkedPaid: "Marquée comme payée",
        violationDismissed: "Classée",
        exportSuccess: "Export effectué",
        lpnSuggestTip: "Utiliser le prochain numéro de plaque disponible pour cette région",
        lpnUseSuggest: "Utiliser suggéré",
        lpnNextAvailable: "Prochain disponible",
        issueAndPrint: "Émettre & imprimer",
        violationPrintedOnSpot: "Contravention imprimée sur place",
        violationPrintFailed: "Échec impression — contravention enregistrée",
        aluminumElectric: "Électrique (E)",
        plateAlertsTitle: "Alertes de plaque",
        plateAlertsHint: "Abonnez cet appareil pour recevoir une notification dès qu'une infraction est émise sur votre plaque.",
        plateAlertsSubscribe: "S'abonner",
        plateAlertsEnrolled: "Vous êtes abonné aux alertes.",
        plateAlertsEnrolledLong: "Abonné — vous recevrez une notification à chaque contravention émise pour cette plaque.",
        plateAlertsNotSupported: "Web Push non pris en charge par ce navigateur.",
        plateAlertsPermissionDenied: "Autorisation refusée.",
        plateAlertsPrivacy: "Nous ne conservons que le numéro et le point d'abonnement navigateur. Résiliez à tout moment.",
        ownerPortalTitle: "Portail propriétaire",
        ownerPortalHint: "Saisissez votre numéro de plaque et votre pièce d'identité pour voir les infractions en cours et payer en ligne.",
        ownerPortalLookup: "Rechercher",
        ownerPortalPrivacy: "Nous vérifions la pièce d'identité contre l'empreinte chiffrée capturée à l'émission de la plaque — rien n'est stocké.",
        ownerPortalOpen: "Infractions ouvertes",
        ownerPortalHistory: "Historique",
        ownerPortalNoOpen: "Aucune infraction ouverte. Tout est en règle.",
        ownerPortalOpenTotal: "Total dû",
        ownerPortalPay: "Payer",
        ownerPortalPaid: "Paiement confirmé",
        citationVerifyTitle: "Vérification de contravention",
        citationVerifyHint: "Ceci est une vue publique en lecture seule d'une contravention UTAL MEA, ouverte via le QR d'un PDF imprimé.",
        citationVerifyFooter: "Les données affichées correspondent au dossier. Contester sous 14 jours au bureau de circulation le plus proche.",
        citationVerifyPayCta: "Propriétaire ? Payer en ligne →",
        citationSignatureTitle: "Signature cryptographique",
        citationSignatureValid: "Vérifiée",
        citationSignatureInvalid: "Invalide",
        citationSignatureAlgo: "Algorithme",
        citationSignatureHelp: "Cette contravention a été signée avec la clé Ed25519 du ministère au moment de l'émission. Toute altération invalide la signature.",
    },
};
